import { Box, type BoxProps } from '@prose-ui';

type BadgeProps = {
  top?: BoxProps['top'];
  left?: BoxProps['left'];
  right?: BoxProps['right'];
  bottom?: BoxProps['bottom'];
  color?: BoxProps['color'];
  bgColor?: BoxProps['bgColor'];
  border?: BoxProps['border'];
  borderColor?: BoxProps['borderColor'];
  size: string;
  children: React.ReactNode;
};

export const Badge = ({
  size,
  children,
  top,
  left,
  right,
  bottom,
  color = 'neutral.900',
  bgColor = 'highlight.200',
  border,
  borderColor,
}: BadgeProps) => {
  return (
    <Box
      __height={size}
      __width={size}
      alignItems="center"
      bgColor={bgColor}
      border={border}
      borderColor={borderColor}
      borderRadius="360"
      bottom={bottom}
      color={color}
      display="flex"
      justifyContent="center"
      left={left}
      position="absolute"
      right={right}
      top={top}
    >
      {children}
    </Box>
  );
};
